import * as React from 'react';

// Components
import LazyLoad from '@stardust/lazy-load';

// Utils
import { MART_SEARCH_RESULT_TYPE } from '@shopee/search-common-util';

// Types
import type { SearchParams } from '@shopee/search-common-util';

type SearchResultType = MART_SEARCH_RESULT_TYPE;

type Props = {
  resultType: SearchResultType;
  searchParams: SearchParams;
  onSearchParamsChange: (newParams: SearchParams) => void;
};

const MartSearchResultMessage = (props: Props) => {
  return (
    <>
      {getQueryRewriteMessage(props)}
      {getNoResultMessage(props)}
    </>
  );
};

function getQueryRewriteMessage({ resultType, searchParams }: Props) {
  if (
    resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT_IMPLICIT ||
    resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT_EXPLICIT
  ) {
    return (
      <MartSearchComplementCorrectedResult
        resultType={resultType}
        keyword={searchParams.complementKeyword || ''}
        actualKeyword={searchParams.keyword || ''}
      />
    );
  }

  return null;
}

function getNoResultMessage({
  resultType,
  searchParams,
  onSearchParamsChange,
}: Props) {
  if (resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT) {
    return <MartSearchNoResultGeneral />;
  }

  if (resultType === MART_SEARCH_RESULT_TYPE.NO_RESULT_FILTER) {
    return (
      <SearchNoResultFilterApplied
        searchParams={searchParams}
        onSearchParamsChange={onSearchParamsChange}
      />
    );
  }

  return null;
}

const MartSearchComplementCorrectedResult = LazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "SearchComplementCorrectedResult" */ '../MartSearchComplementCorrectedResult'
    ),
});

const SearchNoResultFilterApplied = LazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "SearchComplementFilterApplied" */ '../SearchComplementBlock/components/SearchComplementFilterApplied'
    ),
});

const MartSearchNoResultGeneral = LazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "MartSearchNoResultGeneral" */ './MartSearchNoResultGeneral'
    ),
});

export default MartSearchResultMessage;
